<template>
  <!--  -->
  <div class="z-main z-Index">
	<!-- 标题 z-Index-title z-flex-->
	<header class="z-header" style="border-bottom:0px;">
		<div>
			<!-- <img class="index-header-logo" :src="logo"> -->
		</div>
		<div><!-- <img class="index-logo-center" :src="logo"> --><B>DOX</B></div>
		<div @click="service"><img class="z-my-left-icon" src="../assets/my/service.png"></div>
	</header>
    <!-- <div class="app" v-if="appdownshow">
      <span>Open With An App.</span>
      <span>
        <a href="https://okshh.cc/">Download</a>
        <a @click="Close" href="javascript:void(0)">Close</a>
      </span>
    </div> -->
	<!-- 内容  -->
	<div class="z-body" :style="{height:(windowHeight-100)+'px'}">
	  <div class="z-body-in">
		<!-- 轮播图 delimiter-icon="mdi-minus" -->
		<div class="index-padding-lr">
			<v-carousel
				interval="3000"
				height="190"
				hide-controls
			>
				<v-carousel-item v-for="(item, i) in carousel" :key="i">
					<img :src="item.src" style="height:100%;width: 100%;">
					<!-- <router-link :to="{path:'/index/noticeDetail',query:{id:item.href}}">
						<img :src="item.src" style="height:100%;width: 100%;">
					</router-link> -->
				</v-carousel-item>
			</v-carousel>
		</div>
		<!-- 公告 -->
		<div class="index-padding-lr">
			<div class="z-notice z-flex">
				<img src="../assets/common/notice.png" style="height:17px;width:17px;">
				<router-link :to="{path:'/index/noticeDetail',query:{id:notice.id}}">
					<span class="z-notice-title dark-color" v-text="notice.title"></span>
				</router-link>
				<router-link :to="{path:'/index/notice',query:{type:'notice'}}"
					class="z-notice-more dark-color">
					<img src="../assets/index/toright.png" style="width:15px;">
				</router-link>
			</div>
		</div>
		<!-- 热门的期货 -->
		<div class="z-hot z-flex" style="display: flex;flex-wrap: wrap;justify-content: space-between;align-items: flex-start;">
		  <template v-for="(item,index) in hot">
			<router-link class="z-flex" :to="{path:'/futures/kline',query:{id:item.id,fid:item.id,is_main:item.is_main,fname:item.title,symbol:item.symbol,code:item.symbol,api:2,from:'index'}}">
			  <span class="dark-color" v-text="item.title" style="font-size:14px;"></span>
			  <span :style="{color:item.zfrate>0 ? kStyle.up.color : kStyle.down.color}" v-text="item.price"></span>
			  <span :style="{width: '60%',background:item.zfrate>0 ? kStyle.up.color : kStyle.down.color}" v-text="item.zfrate>0 ? '+'+item.zfrate+'%' : item.zfrate+'%'"></span>
			</router-link>
		  </template>
		</div>
		<!-- 快讯 -->
		<!-- <div class="index-padding-lr" style="border-bottom: 10px solid #F8F8F8;">
			<div class="z-notice z-flex">
				<img src="../assets/index/kx@2x.png" style="height:17px;width:auto;">
				<router-link :to="{path:'/index/noticeDetail',query:{id:kuaixun.id}}">
					<span class="z-notice-title dark-color" v-text="kuaixun.title"></span>
				</router-link>
				<router-link :to="{path:'/index/notice',query:{type:'kuaixun'}}"
					class="z-notice-more dark-color">
					<img src="../assets/index/toright.png" style="width:15px;">
				</router-link>
			</div>
		</div> -->
		<!-- 充值 -->
		<div class="index-recharge-box">
			<router-link :to="{path:'/my/recharge'}">
			<div class="index-recharge-box-in">
				<div>
					<h2>{{$t('快捷买币')}}</h2>
					<span>{{$t('轻松购买数字资产')}}</span>
				</div>
				<div>
					<img src="../assets/index/recharge-img.png">
				</div>
			</div>
			</router-link>
		</div>
		<!-- 其他类别显示一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一 -->
		<!-- 标题栏 -->

		<!-- 列表表头 -->
		<div class="z-Hq-list-th z-flex">
		  <div style="width: 20%;">{{$t('名称')}}</div>
		  <div style="width: 30%;text-align:center;">{{$t('价格')}}</div>
		  <div style="width: 20%;">{{$t('今日涨跌幅')}}</div>
		</div>
		<!-- 列表数据 -->
		<div class="z-Hq-list z-flex">

		  <template v-for="(item,index) in hot_other">
			<router-link class="z-flex z-Hq-list-a" :id="'hq'+item.id" :to="{path:'/futures/kline',query:{id:item.id,fid:item.id,is_main:item.is_main,fname:item.title,symbol:item.symbol,code:item.symbol,api:2,from:'index'}}">
			  <div class="dark-color" v-text="item.title"></div>
			  <div>
				<span style="color:#70757D;font-size:12px;" v-text="item.price"></span>
			  </div>
			  <div :style="{background:item.zfrate>0 ? kStyle.up.color : kStyle.down.color}" v-text="item.zfrate>0 ? '+'+item.zfrate+'%' : item.zfrate+'%'"></div>
			</router-link>
		  </template>

		</div>
	  </div>
	</div>

	<v-dialog v-model="isShopShow" max-width="290" style="position: relative; z-index: 999999;">
	  <v-card light>
		<v-card-title>{{$t('提示')}}</v-card-title>
		<v-card-text>{{$t('功能正在开发，敬请期待！')}}</v-card-text>
		<v-card-actions>
		  <v-spacer></v-spacer>
		  <v-btn color="green darken-1" flat="flat" @click="isShopShow=false">{{$t('关闭')}}</v-btn>
		</v-card-actions>
	  </v-card>
	</v-dialog>

	<!-- <v-dialog v-model="isShowHelp" max-width="290" style="position: relative; z-index: 999999;">
	<v-card light>
	  <v-card-title>提示</v-card-title>
	  <v-card-text>功能正在开发，敬请期待！</v-card-text>
	  <v-card-actions>
		<v-spacer></v-spacer>
		<v-btn color="green darken-1" flat="flat" @click="closeHelp">关闭</v-btn>
	  </v-card-actions>
	</v-card>
  </v-dialog> -->

	<!-- 时间内弹窗 -->
	<v-dialog v-model="isShowHint" max-width="290">
	  <v-card light>
		<v-card-title class="headline">{{dialogContent.title}}</v-card-title>
		<v-card-text>{{dialogContent.content}}</v-card-text>
		<v-card-actions>
		  <v-spacer></v-spacer>
		  <v-btn color="green darken-1" flat="flat" @click="isShowHint=false">{{$t('关闭')}}</v-btn>
		</v-card-actions>
	  </v-card>
	</v-dialog>

	<!-- 底部菜单 -->
	<div style="height:48px;"></div>
	<ButtomMenu active="0" />
  </div>
</template>
<script>
  import ButtomMenu from '../components/ButtomMenu'
  export default {
	name: 'index',
	components: {
	  ButtomMenu
	},
	data() {
	  return {
	  	logo:require('../assets/index/logo-center.png'),
		mine: {
		  id: 0, //用户id
		  name: this.$t('请先登录'), //用户名称
		  is_act: 0, //是否激活 0未激活  1已激活
		  lv: this.$t('无'), //代理等级
		  profit: 0, //收益金
		  extend: 0, //推广金
		  agent: 0, //代理金
		},
		title: '',
		drawer: false, //左侧弹框开关
		selectIdx: -1,
		shop_url: '',
		cycle: false,
		carousel: [],
		notice: {},
		kuaixun: {},
		hot: [],
		list: [],
		news: [],
		symbols: [],
		eventInterval: null,
		dialog: false,
		colseEvent: null,
		isShopShow: false,
		isShow: false,
		isShowHelp: false,
		hot_other: [],
		isShowHint: false,
		dialogContent: {
		  title: '',
		  content: ''
		},
		//关于我们文章ID
		about_us_id: 0,
    appdownshow:true,
	  }
	},
	inject: ['reload'],
	watch: {
	  '$store.state.webscoketObj.readyState': function(newV) { //监听长连接状态
		let _this = this
		_this.colseEvent = setTimeout(function() {
		  // _this.reload()
		}, 1500)
	  },
	},
	created() {
		let _this = this
        //绑定cliend_id
        if (_this.getClientId() && _this.getToken()) {
          _this.get('api/users/bindclientid', {
            client_id: _this.getClientId()
          })
        }
	},
	mounted() {
	  this.init()
	},
	methods: {
	  playVideo() {
		var vdo = document.getElementById("playVideo");
		vdo.play();
	  },
	  init() {
		let _this = this
		_this.get('api/Futures/index', {
		  page: 1
		}).then((res) => {
		  let data = res.data;
		  _this.about_us_id = data.about_us_id
		  _this.carousel = data.carousel
		  _this.notice = data.notice
		  _this.kuaixun = data.news
		  _this.list = data.list
		  _this.shop_url = data.shop_url
		  let hot = data.list
		  _this.hot = hot.slice(0, 3)
		  // _this.hot_other = hot.slice(3)
		  _this.hot_other = hot
		  for (var i = 0; i < _this.list.length; i++) {
			_this.symbols.push(_this.list[i].symbol)
		  }
		  //长连接 - 检测和接收数据
		  _this.wsCheck()
		})
		// _this.get('api/users/mine', {}).then((res) => {
		//   if (res.code == 0) {
		// 	_this.mine = res.data
		//   }
		// })
	  },
	  wsCheck() { //长连接 - 检测状态后数据接收
		let _this = this;
		//长连接状态正常才发送
		if (_this.$store.state.webscoketObj && _this.$store.state.webscoketObj.readyState == 1) {
		  clearInterval(_this.eventInterval)
		  _this.$create_wsConfig(_this, _this.symbols.join(','), _this.getToken(), 0)
		  _this.$store.state.webscoketObj.onmessage = _this.processData
		} else { //长连接状态不正常，则轮询
		  _this.eventInterval = setInterval(function() {
			clearInterval(_this.eventInterval)
			_this.wsCheck()
		  }, 1000)
		}
	  },
	  processData(e) {
		let _this = this
		var rs = JSON.parse(e.data);
		if (rs.type == 'hangqing') {
		  let data = rs.data[0];
		  let list = _this.list;
		  for (let i = 0; i < list.length; i++) {
			let item = list[i];
			if (item.id == data.fid) {
			  _this.list[i]['zfrate'] = data.zfrate
			  _this.list[i]['price'] = data.last_price
			  break;
			}
		  }
		}
		else if (rs.type == 'init') { //绑定cliend_id
			_this.get('api/users/bindclientid', {client_id:data.client_id})
		}
	  },
	  onLeftMenu(e) {
		switch (e) {
		  case 'outmoney':
			this.drawer = false
			this.dialog = true
			break;
		}
	  },
	  outmoneyPost() {
		this.post('api/users/returns', {}).then((rs) => {
		  this.$store.commit('layer', rs.msg)
		  this.dialog = false
		})
	  },
	  close() {
		this.isShow = false
	  },
	  closeHelp() {
		this.isShowHelp = false
	  },

	  onNewDialog() {
		this.get('api/futures/index', {}).then((res) => {
		  if (res.code == 0) {
			if (res.data.popmsg && res.data.popmsg.length > 0) {
			  this.dialogContent = res.data.popmsg
			  this.isShowHint = true
			} else {
			  return
			}
		  }
		  return
		})
	  },
    service(){
       window.location.href = "https://t.me/DOX0100";
     },
    Close(){
      this.appdownshow = false;
    }

	},
	destroyed() {
	  let _this = this;
	  clearTimeout(_this.colseEvent)
	}
  }
</script>
<style scoped>
.app{
  display: flex;
  justify-content: space-between;
  padding: 4px 10px;
  background: #05A878;
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  z-index: 100;
  color: #fff;
}
.app a{color: #fff;margin-left: 10px;border: 1px solid #fff;padding: 2px 5px;font-size: 12px;border-radius: 4px;}
.index-recharge-box {
	border-bottom: 1px solid #515151;
}
.index-recharge-box-in {
	display: -webkit-flex;
  display: flex;
  align-items:center;
}
.index-recharge-box-in div{
	text-align: center;
	width: 50%;
}
.index-recharge-box-in h2{
	padding-bottom: 10px;
}
.index-recharge-box-in img{
	height: 100px;
}
.index-padding-lr {
	padding:0px 12px;
}
.index-header-logo {
	width: auto;
    height: 18px;
    margin-top: 10px;
}
.index-logo-center {
	width: auto;
    height: 34px;
    margin-top: 8px;
}
  .z-index-left-amount {
	background: #21222D;
	margin: 10px;
	padding: 10px;
	border-radius: 5px;
  }

  .z-index-left-amount-item {
	font-size: 18px;
	color: #DCB77C;
  }

  .z-index-left-amount div {
	flex-direction: column;
  }

  .z-index-left-title {
	padding: 15px;
	padding-top: 30px;
	border-bottom: 3px solid #202128;
	border-bottom: 3px solid #fff;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	background: #212329;

  }

  .z-index-left-items {
	padding: 12px 10px !important;
	border-bottom: none !important;
  }

  .z-index-left-toicon {
	width: 10px !important;
	height: 10px !important;
  }

  .z-index-left-items-childs {
	/* background: #393E4A; */
	background: #fff;
  }

  .z-index-left-items-childs-a {
	justify-content: flex-start;
	padding: 10px 37px !important;
	/* color: #9898A4; */
	color: gray;
  }

  .z-Index {
	/* margin-bottom: 47px */
  }

  .z-Index-title {
	padding: 15px;
	justify-content: space-between;
	/* font-size:18px;
	font-family:PingFang SC;
	font-weight:800;
	color:#E2B96F; */
  }

  .z-Index-title img {
	width: 16px;
  }

  .z-Index-title span:first-child {
	font-size: 24px;
  }

  .z-Index .z-notice {
	 border-bottom: 1px solid #515151;
	justify-content: flex-start;
	padding-top: 15px;
	padding-bottom: 15px;
	font-size: 14px;
	color: #6A6E76;
  }

  .z-Index .z-notice-title {
	padding-left: 10px;
	color: white;
  }

  .z-Index .z-notice-more {
	margin-left: auto;
	color: #B5B7BA;
  }

  .z-hot {
	padding: 10px;
	font-size: 14px;
	text-align: center;
	border-bottom: 1px solid #515151;
  }

  .z-hot a {
	flex-direction: column;
	width: 33%;
  }

  .z-hot span {
	color: #05A878;
	font-size: 14px;
  }

  .z-hot span:first-child {
	color: white;
	font-size: 16px;
  }

  .z-hot span:nth-child(2) {
	padding: 2px;
  }

  .z-hot span:nth-child(3) {
	font-size: 10px;
	color: white;
	padding: 5px 8px;
	border-radius: 2px;
  }

  .z-Index-list-title {
	padding: 10px;
	color: #E2B96F;
	border-bottom: 1px solid #2f2b2b;

  }

  .z-Index-list {
	padding: 0px 10px;
	flex-direction: column;
  }

  .z-Index-list-items {
	justify-content: space-between;
	padding: 12px 0px;
	border-bottom: 1px solid #2f2b2b;
	/* color: #B5B7BA; */
	color: #000;
	font-size: 15px;
  }

  .z-Index-list-items img {
	width: 17px;
	height: 17px;
  }

  .z-Index-list-a {
	width: 100%;
	padding: 5px 0px;
	justify-content: space-between;
	border-bottom: 1px solid #2f2b2b;
	text-align: center;
	color: #9898A4;
  }

  .z-index-video {
	padding: 0px 10px 10px 10px;
	border-radius: 5px;
  }


  .z-Hq {
	margin-bottom: 47px
  }

  .z-Hq-bar-title {
	background: #1e1f23;
	height: 47px;
	justify-content: space-between;
	color: white;
	padding: 0px 10px;
	font-size: 18px;
	border-bottom: 1px solid #2f2b2b;
  }

  .z-Hq-list-th {
	justify-content: space-between;
	padding: 5px 10px;
	color: #7C8086;
	font-size: 12px;
	padding: 10px 10px;
  }
  .z-Hq-list-th div:nth-child(2) {
	width: 33%;
	text-align: center;
  }

  .z-Hq-list-item-title {
	color: #7C8086;
	font-size: 16px;
	align-self: flex-start;
	background: #1C2023;
	padding: 5px 10px;
	border-radius: 10px;
  }

  .z-Hq-list-title {
	padding: 10px;
	color: #E2B96F;
	border-bottom: 1px solid #2f2b2b;
  }

  .z-Hq-list {
	flex-direction: column;
	margin-bottom: 30px;
  }

  .z-Hq-list-a {
	width: 100%;
	padding: 10px 10px;
	justify-content: space-between;
	border-bottom: 1px solid #515151;
	text-align: center;
  }

  .z-Hq-list-a div:nth-child(1) {
	width: 20%;
	text-align: left;
	color: white;
  }

  .z-Hq-list-a div:nth-child(2) {
	width: 30%;
	color: #00C087;
  }

  .z-Hq-list-a div:nth-child(3) {
	width: 20%;
	color: white;
	padding: 5px 8px;
	border-radius: 2px;
	font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue